<template>
  <section>
    <v-dialog v-model="show" fullscreen>
      <v-card flat>
        <v-container>
          <div class="dialog-toolbar">
            <v-col cols="9" md="11">
              <h3>Horario de llegada</h3>
            </v-col>
            <v-col cols="1" md="1" class="close-icon-container">
              <v-icon
                @click="$emit('close-dialog')"
                style="transform: translateX(-15px)"
                >close</v-icon
              >
            </v-col>
          </div>
          <div style="height: 50px"></div>
          <v-row>
            <v-col cols="12" style="padding-bottom: 0">
              <h4>ID: {{ requestId }}</h4>
            </v-col>
            <v-col cols="12">
              <p style="margin: 0">{{ requestAddress }}</p>
            </v-col>
            <v-col cols="12">
              <v-btn @click="minutesDelay(15)" color="secondary" dark block
                >15 min</v-btn
              >
            </v-col>
            <v-col cols="12">
              <v-btn @click="minutesDelay(30)" color="secondary" dark block
                >30 min</v-btn
              >
            </v-col>
            <!-- Comentadas piden 15 y 30 min -->
            <!-- <v-col v-if="!mobsUser" cols="12">
              <v-btn @click="minutesDelay(45)" color="secondary" dark block
                >45'</v-btn
              >
            </v-col>
            <v-col cols="12">
              <v-btn
                v-if="!mobsUser"
                @click="minutesDelay(60)"
                color="secondary"
                dark
                block
                >60'</v-btn
              >
            </v-col> -->
            <v-col cols="12">
              <p style="font-size: 14px; margin: 0">
                Si estas demorado por favor indica la hora exacta de llegada
              </p>
            </v-col>
            <v-col cols="12">
              <v-dialog
                ref="dialog"
                v-model="timePickerDialog"
                :return-value.sync="time"
                persistent
                width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="time"
                    label="Seleccionar horario"
                    prepend-icon="access_time"
                    readonly
                    @change="selectDate()"
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-time-picker
                  v-if="timePickerDialog"
                  v-model="time"
                  :min="now"
                  full-width
                  format="24hr"
                  locale="es-ar"
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="timePickerDialog = false">
                    Cancel
                  </v-btn>
                  <v-btn text color="primary" @click="$refs.dialog.save(time)">
                    OK
                  </v-btn>
                </v-time-picker>
              </v-dialog>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </section>
</template>
<script>
import moment from "moment";

export default {
  props: {
    show: Boolean,
    requestId: Number,
    requestAddress: String,
    visitId: Number,
  },
  data() {
    return {
      timePickerDialog: false,
      time: null,
      now: moment().format("HH:mm"),
    };
  },
  computed: {
    mobsUser() {
      return this.$store.state.mobsUser;
    },
  },
  methods: {
    minutesDelay(minutes) {
      const body = { id: 1, minutes_delay: minutes, time_delay: null };
      this.axios
        .post(`/visit/${this.visitId}/status/`, body)
        .then((response) => {
          this.$store.commit(
            "show_alert",
            "Se ha notificado el horario de llegada"
          );
          this.$emit("close-dialog");
        })
        .catch(() => {
          this.$store.commit("show_alert", "Ha ocurrido un error");
        });
    },
    selectDate() {
      const body = { id: 1, minutes_delay: null, time_delay: this.time };
      this.axios
        .post(`/visit/${this.visitId}/status/`, body)
        .then((response) => {
          this.$store.commit(
            "show_alert",
            "Se ha notificado el horario de llegada"
          );
          this.$emit("close-dialog");
        })
        .catch(() => {
          this.$store.commit("show_alert", "Ha ocurrido un error");
        });
    },
  },
};
</script>

<style scoped>
@media (min-width: 960px) {
  .close-icon-container {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
